import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface federalStateInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: federalStateInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const federalStateSlice = createSlice({
  name: 'federalStateSlice',
  initialState,
  reducers: {
    setFederalStateTotalPages: (
      state: federalStateInitialSliceI,
      actions: PayloadAction<federalStateInitialSliceI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
